<template>
  <div
    class="com-item"
    :key="index">
    <div class="component person-nav" ref="slider_page">
      <template v-if="modata.WContent.nav && modata.WContent.nav.length>0">
        <div v-if="modata.WContent.IsShowTags == 1">
          <div class="tags-wrap" :style="{marginBottom: (modata.WContent.TagesSpacing*proportion) + 'px',}">
            <div class="tags-list" :style="{
                  lineHeight: (modata.WContent.TagsH/rootValue) + 'rem',
                  color: modata.WContent.TagsNameColor,
                  fontSize: ((modata.WContent.TagsFsize||14)/rootValue) + 'rem',
                }">
              <div class="tags-item" v-for="(item, index) in modata.WContent.nav" @click="handToSlide(index)" :key="index" :style="index==activeIndex?{borderBottomColor:modata.WContent.TagsCheckColor||'#333',color:modata.WContent.TagsCheckColor||'#333'}:''">{{ item.TagsName || "导航" }}</div>
            </div>
          </div>
        </div>
        <div class="van-sticky">
          <div :class="modata.WContent.CardType=='card'?'swiper-card':''" v-if="swiperOption">
             <swiper :options="swiperOption" ref="mySwiper" @slideChange="onSlideChange">
            <swiper-slide v-for="(item, index) in modata.WContent.nav" :key="index">
              <img class="img" :src="item.ImgUrl" >
              <btnModule :content-obj="modata.WContent" :nav="item" :proportion="proportion" type="preview" :key="index"></btnModule>
            </swiper-slide>
          </swiper>

         </div>

          <template v-if="modata.WContent.IsShowPagination == 1">
             <div class="swipersSpeed1" v-if="modata.WContent.moduleStyle == 1">
              <div class="indicator" :class="{'is-active':index==activeIndex}" v-for="(item,index) in modata.WContent.nav" :key="index" @click="handToSlide(index)">
                <button class="indicator__button"></button>
              </div>
            </div>
            <div class="swipersSpeed2" v-if="modata.WContent.moduleStyle == 2">
              <div class="indicator" :class="{'is-active':index==activeIndex}" v-for="(item,index) in modata.WContent.nav" :key="index" @click="handToSlide(index)">
                <button class="indicator__button"></button>
              </div>
            </div>
            <template v-if="modata.WContent.moduleStyle == 3">
              <button class="swipers3_arrow swipers3_arrow-left" @click="handPrev">
                <i class="el-icon-arrow-left"></i>
              </button>
              <button class="swipers3_arrow swipers3_arrow-right" @click="handNext">
                <i class="el-icon-arrow-right"></i>
              </button>

            </template>

            <div class="swipersSpeed4" v-if="modata.WContent.moduleStyle == 4">
              <div class="icon" style="margin-right: 18px;" @click="handPrev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="icon" @click="handNext">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import btnModule from "@/components/Custom/BtnModule";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "slider-module",
  props: {
    index: {
      //索引
      type: Number,
    },
    animateShow: {
      type: String,
    },
    phoneWidth: {
      type: Number,
      default: 1280,
    },
    curpageWidth: {
      type: Number,
      default: 1280,
    },
     proportion: {
        type: Number,
        default:1,
    },
    modata: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {
          WName: "slider",
          Title: "轮播",
          PageID: "",
          WID: 1,
          ModuleName: "slider-module",
          WContent: {},
        };
      },
    },
  },
  components: {
    swiper,
    swiperSlide,
    btnModule,
  },
  data() {
    return {
      //预览
      swipersCurrent: 0,
      rootValue: this.$store.state.rootValue || 1,

      activeIndex: 0,

      swiperOption: null,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // var nav = this.modata.WContent.nav || [];
    // if (nav.length > 0 && nav[0].FileWidth) {
    //   this.modata.WContent.swipersHeight =(this.curpageWidth / nav[0].FileWidth) * nav[0].FileHeight;
    // }
    let swiperOption={
        loop: true,
        spaceBetween: 20,
        centeredSlides: true, // 每屏，居中显示
        slidesPerView: "auto", // 默认一个屏幕显示几张图，必须auto！要不轮播到最后一张图时，右侧会是空白，很丑！
        loopedSlides: 3,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // setWrapperSize :true,
        autoHeight: true,
        observer: true,
        observeParents: true,
      }
    let WContent=this.modata.WContent;
    if(WContent.AutoChangState){
      swiperOption.autoplay.delay=(WContent.AutoChangeSec||5)*1000

    }else{
      swiperOption.autoplay=false;
    }
    this.swiperOption=swiperOption;
  },
  beforeDestroy() {},
  methods: {
    handPrev() {
      this.swiper.slidePrev();
    },
    handNext() {
      this.swiper.slideNext();
    },
    handToSlide(index) {
      this.swiper.slideToLoop(index, 1000, false);
    },

    onSlideChange(e) {
      let activeIndex = this.swiper.realIndex;
      // if(activeIndex>this.modata.WContent.nav.length){
      //   activeIndex=1;
      // }
      this.activeIndex = activeIndex;
    },

    bindPage(item) {
      if (!item.btn) {
        this.pageNavigate(item.linkUrl);
      }
    },

    pageNavigate(path) {
      if (!path) {
        return;
      }
      if (/^(https?:|mailto:|tel:)/.test(path)) {
        window.open(path);
      } else {
        this.$router.push(path);
      }
    },
  },
  filters: {},
};
</script>



<style scoped lang="scss">
.decorate-editor-cont .el-collapse-item__wrap {
  border-bottom: none;
}

.van-sticky {
  position: relative;
  overflow: hidden;
}
.van-sticky .img {
  display: block;
  width: 100%;
  height: auto;
}

.swiper-card{
  .swiper-container {
    overflow: visible!important;
    width: 80%;  // 设置每个轮播的宽度，数值越小，两边显示的会越大
  }
  .swiper-container .swiper-wrapper .swiper-slide{ 
    border-radius: 10px;         
  }
  .swiper-slide-prev::after,.swiper-slide-next::after{
    content: "";
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.5);
    position: absolute;
    top: 0;
    left: 0;
  }

}

.swiper-container .swiper-wrapper .swiper-slide img{ 
  width: 100%;
  height: 100%;
}




/* 样式1 横条 */
 .indicator{
    display: inline-block;
    padding: 12px 4px;
    background-color: transparent;
    cursor: pointer;
 }
  .indicator__button {
      display: block;
      opacity: .48;
      width: 30px;
      height: 2px;
      background-color: #FFF;
      border: none;
      outline: 0;
      padding: 0;
      margin: 0;
      cursor: pointer;
      -webkit-transition: .3s;
      transition: .3s;
  }
  .indicator.is-active .indicator__button {
      opacity: 1;
  }

.swipersSpeed1{
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: 2;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.swipersSpeed2{
  text-align: center;
      transform: none;
  .indicator__button{
       background-color: #C0C4CC;
  }
}

.swipers3_arrow{
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    height: 36px;
    width: 36px;
    cursor: pointer;
    -webkit-transition: .3s;
    transition: .3s;
    border-radius: 50%;
    background-color: rgba(31,45,61,.11);
    color: #FFF;
    position: absolute;
    top: 50%;
    z-index: 10;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: center;
    font-size: 12px;
}
.swipers3_arrow-left{
  left: 16px;
}

.swipers3_arrow-right{
  right: 16px;
}




/* 样式2 外部横条 */

/* 样式3 箭头 */

/* 样式4  外部箭头*/
.swipersSpeed4 {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}
.swipersSpeed4 .icon {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  background-color: #333;
  color: #fff;
  text-align: center;
  line-height: 32px;
  font-size: 15px;
}




/**导航 */
.tags-wrap {
  font-size: 13px;
  border-bottom: solid 1px #f2f2f2;
  margin-bottom: 8px;
}
.tags-list{
  display: flex;
  flex-direction: row;
  justify-content: center;
   line-height: 42px;
}
.tags-item{
 flex: none;
  border-bottom: solid 2px transparent;
  padding: 0 20px;
}

</style>
